import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
  page: {
    padding: theme.spacing(2),
  },
}));
